export const DEFAULT_HEX_DISPLAY_OPTIONS = Object.freeze({
  showShading: true,
  showDots: true,
});

export function hexLayerPresentation(options = DEFAULT_HEX_DISPLAY_OPTIONS) {
  const showShading = options.showShading !== false;
  const showDots = options.showDots !== false;
  return {
    showShading,
    showDots,
    useBlackBoundary: showDots && !showShading,
  };
}
